import {
  calculateMinPossibleBaseAmount,
  calculateMaxPossibleBaseAmount,
  calculateMinPossibleProcessingAmount,
  calculateMaxPossibleProcessingAmount,
} from 'utils/helper-functions/limits-calculation';

interface SideLimits {
  min: number | null;
  max: number | null;
}

export interface ModernRetryLimits {
  processing: SideLimits;
  base: SideLimits;
}

// The limits the Panoramic modern retry hint shows with a conversion: the fee-affected
// processing limits while the processing currency is edited, the converted base limits while
// the base currency is edited. The main check compares each side with the limit its hint shows.
// A null bound means the hint falls back to the raw gateway limit, which the check does too.
// There is no failed-charge cap on the modern field.
export const getModernRetryLimits = (
  currency: string | null | undefined,
  gateway?: Record<string, any>,
): ModernRetryLimits | null => {
  if (!currency || !gateway) return null;

  return {
    processing: {
      min: calculateMinPossibleProcessingAmount(currency, gateway) || null,
      max: calculateMaxPossibleProcessingAmount(currency, gateway) || null,
    },
    base: {
      min: calculateMinPossibleBaseAmount(currency, gateway) || null,
      max: calculateMaxPossibleBaseAmount(currency, gateway) || null,
    },
  };
};
